<template>
    <div class="container">
        <v-row>
            <v-col cols="6" sm="4" md="3" lg="2" v-for="skill in skills" :key="skill.title.split(' ')[0]">
                <div class="v-card pa-3">
                    <div class="v-card__body">
                        <div class="text-center">
                            <v-progress-circular
                                    :rotate="360"
                                    :size="100"
                                    :width="15"
                                    :value="skill.score"
                                    :color="skill.color"
                            >
                                {{ skill.score }}
                            </v-progress-circular>
                        </div>
                        <div class="v-card__actions"><h4 class="text-center">{{ skill.title }}</h4></div>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "Skills",
        mounted() {
            for(let i = 0; i < this.skills.length; i++) {
                let score = this.skills[i].score
                this.skills[i].score = setInterval(() => {
                    if (this.skills[i].score >= score) {
                        return (this.skills[i].score = score)
                    }
                    else {
                        this.skills[i].score += 5
                    }
                }, 100)
            }
        },
        destroyed() {
            for(let i = 0; i < this.skills.length; i++) {
                clearInterval(this.skills[i].score)
            }
        },
        data() {
            return {
                skills : [
                    {
                        title: "Laravel",
                        score: 87,
                        color: "red"
                    },
                    {
                        title: "Vuejs",
                        score: 80,
                        color: "teal"
                    },
                    {
                        title: "Nuxt",
                        score: 68,
                        color: "teal darken-4"
                    },
                    {
                        title: "R-Database",
                        score: 82,
                        color: "lime darken-4"
                    },
                    {
                        title: "Python",
                        score: 84,
                        color: "green"
                    },
                    {
                        title: "Data Science",
                        score: 75,
                        color: "orange"
                    },
                    {
                        title: "Machine Learning",
                        score: 70,
                        color: "amber darken-4"
                    },
                ],
                scores: []
            }
        },
        methods: {
            setZero(skill) {
                this.scores.push(skill.score)
                skill.score = 0
            },
            setBack(skill) {
                skill.score = this.scores.pop()
            }
        }
    }
</script>

<style scoped>

</style>